import { useCallback, useState } from 'react';
import { applyThemePreference } from './applyThemePreference.js';

/** The person's theme choice (system, light or dark) and a setter that saves and draws it. */
const useThemePreference = () => {
  const [preference, setPreference] = useState(() => document.documentElement.dataset.themePreference || 'system');

  const choose = useCallback((nextPreference) => {
    applyThemePreference({ preference: nextPreference });
    setPreference(nextPreference);
  }, []);

  return [preference, choose];
};

export default useThemePreference;
